import React, { Component } from "react";
import { TouchableOpacity, View ,Image} from "react-native";
import TextView from "./TextView";
import { componentStyles, appStyles, homeStyles } from "../theme/styles";
import Waiting from "./Waiting";
import LinearGradient from "react-native-linear-gradient";
import { greenLightColor, greenDarkColor } from "../theme/colors";
import { wp } from "../utils/responsive";

export default class ChoseServantItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            waiting: false,
        }
    }

    render() {
        var item = this.props.data;
        return (
            <View style={[componentStyles.favoirtExpertItem, { width: wp(70) }]}>
                <View style={appStyles.row}>

                    <View>
                        <TextView style={{ color: '#424242' }}>{item.name}</TextView>
                        <TextView style={{ color: 'gray', margin: 5, textAlign: 'right' }}>({item.job})</TextView>
                    </View>
                    <View style={componentStyles.fservantImage}>
                        <Image
                            source={{ uri: item.pic }}
                            style={componentStyles.iservantImage} />
                    </View>
                </View>

                <TouchableOpacity style={{ alignSelf: 'center' }} onPress={() => {
                    this.props.onChosen()
                }}>
                    <LinearGradient start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }}
                        colors={[greenLightColor, greenDarkColor]} style={homeStyles.favExbutton}>
                        <TextView style={{ color: 'white' }}>درخواست خدمت</TextView>
                    </LinearGradient>
                </TouchableOpacity>
                <Waiting waiting={this.state.waiting} />
            </View>
        );
    }
}


